module.exports = __webpack_public_path__ + "static/img/wsd1040.5990a49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wsd1040.jpg
// module id = JWDG
// module chunks = 0